var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogle = function SvgGoogle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 4.5,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4613_275816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7664 9.9125H11.1211V12.2328H14.3461C14.207 12.9828 13.7852 13.6172 13.1492 14.0422C12.6117 14.4016 11.9258 14.6141 11.1195 14.6141C9.55859 14.6141 8.23828 13.5594 7.76641 12.1422C7.64766 11.7828 7.57891 11.3984 7.57891 11.0031C7.57891 10.6078 7.64766 10.2234 7.76641 9.86406C8.23984 8.44844 9.56016 7.39375 11.1211 7.39375C12.0008 7.39375 12.7898 7.69688 13.4117 8.29063L15.1305 6.57031C14.0914 5.60156 12.7367 5.00781 11.1211 5.00781C8.77891 5.00781 6.75234 6.35156 5.76641 8.31094C5.36016 9.12031 5.12891 10.0359 5.12891 11.0047C5.12891 11.9734 5.36016 12.8875 5.76641 13.6969C6.75234 15.6562 8.77891 17 11.1211 17C12.7398 17 14.0961 16.4625 15.0867 15.5469C16.2195 14.5031 16.8742 12.9656 16.8742 11.1391C16.8742 10.7141 16.8367 10.3063 16.7664 9.9125Z",
    fill: "#595959"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 4.5,
    stroke: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4613_275816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "google.1ba3a6b01cf16689cefd46ba4142d280.svg";